<template>
  <form>
    <div class="settings-top-bar sticky-header">
      <div class="top-bar printer-top-bar">
        <div class="printer-heading">
          <span class="printer-heading-icon"><i class="ti-printer"></i></span>
          <div class="printer-heading-text">
            <h2 class="printer-heading-title">{{ $t('printer.title') }}</h2>
            <p class="printer-heading-subtitle">{{ $t('printer.subtitle') }}</p>
          </div>
        </div>
        <p class="d-inline-flex printer-actions">
          <a class="btn btn-orange btn-icon mar-rt-10 back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
          <a class="btn btn-danger btn-icon mar-rt-10 delete" v-if="id" @click.prevent="handleDelete">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15 mar-bt-15 printer-form-wrap">
      <div class="col-lg-12 col-md-12">
        <div class="card printer-form-card">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="card-content">
            <div class="row printer-sections">
              <!-- Left column -->
              <div class="col-lg-6">

                <!-- Informații generale -->
                <div class="settings-section">
                  <div class="settings-section-header">
                    <span class="settings-section-icon"><i class="ti-file"></i></span>
                    <h3>{{ $t('printer.sectionGeneral') }}</h3>
                  </div>
                  <div class="settings-section-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>ID</label>
                          <input type="number"
                            disabled
                            placeholder="ID"
                            v-model="model.id"
                            class="form-control">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('companyOptions.name')}}</label>
                          <input type="text"
                            placeholder="Imprimanta bucatarie locatia 1"
                            v-model="model.name"
                            name="name"
                            v-validate="'required'"
                            :data-vv-as="$t('companyOptions.name')"
                            class="form-control">
                          <small class="text-danger" v-if="errors.has('name')">
                            {{ getError('name') }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{$t('kds.location')}}</label>
                      <v-select
                        v-model="model.location"
                        name="location"
                        :options="locations"
                        v-validate="modelValidations.location"
                        value="id"
                        label="name"
                        :placeholder="$t('kds.location')">
                      </v-select>
                      <small class="text-danger" v-if="errors.has('location')">
                        {{ getError('location') }}
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Conectivitate -->
                <div class="settings-section">
                  <div class="settings-section-header">
                    <span class="settings-section-icon"><i class="ti-plug"></i></span>
                    <h3>{{ $t('printer.sectionConnectivity') }}</h3>
                  </div>
                  <div class="settings-section-body">
                    <div class="form-group label-input" v-if="selectedType && selectedType.id == 5">
                      <label>{{ $t('printer.isLan') }}</label>
                      <p-switch v-model="orderLabelIsLan" type="success"></p-switch>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div v-if="selectedType && selectedType.id == 3 || selectedType && selectedType.id == 2" class="form-group label-input">
                          <label>{{$t('settingCompany.printer_is_usb')}}</label>
                          <p-switch v-model="model.printer_is_usb" type="success" ></p-switch>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <template v-if="selectedType && ((selectedType.id == 5 && !orderLabelIsLan) || (selectedType.id != 5 && model.printer_is_usb))">
                            <label class="control-label">{{$t('settingCompany.hostname')}}</label>
                          </template>
                          <template v-else-if="selectedType && selectedType.id == 5">
                            <label class="control-label">{{ $t('printer.printerIpHost') }}</label>
                          </template>
                          <template v-else>
                            <label class="control-label">{{$t('settingCompany.printerIp')}}</label>
                          </template>
                          <input
                            type="text"
                            v-model="model.ip"
                            name="ip"
                            v-validate="'required'"
                            data-vv-as="IP/Host"
                            class="form-control" >
                          <small class="text-danger" v-if="errors.has('ip')">
                            {{ getError('ip') }}
                          </small>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <template v-if="selectedType && ((selectedType.id == 5 && !orderLabelIsLan) || (selectedType.id != 5 && model.printer_is_usb))">
                            <label class="control-label">{{$t('settingCompany.printerName')}}</label>
                          </template>
                          <template v-else-if="selectedType && selectedType.id == 5">
                            <label class="control-label">{{ $t('printer.printerPortName') }}</label>
                          </template>
                          <template v-else>
                            <label class="control-label">{{$t('settingCompany.printerPort')}}</label>
                          </template>
                          <input
                            type="text"
                            v-model="model.port"
                            name="port"
                            v-validate="'required'"
                            data-vv-as="Port"
                            class="form-control" >
                          <small class="text-danger" v-if="errors.has('port')">
                            {{ getError('port') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Versiune și tip conexiune -->
                <div class="settings-section" v-if="selectedType && selectedType.id == 2 && !model.printer_is_usb">
                  <div class="settings-section-header">
                    <span class="settings-section-icon"><i class="ti-link"></i></span>
                    <h3>{{ $t('printer.sectionVersion') }}</h3>
                  </div>
                  <div class="settings-section-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div v-if="(selectedType && selectedType.id == 2) && !model.printer_is_usb" class="form-group">
                          <label>Version</label>
                          <v-select
                            v-model="model.printer_type"
                            :options="printerTypes"
                            value="id"
                            label="name"
                            placeholder="Standard">
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div v-if="selectedType && (![3,5].includes(selectedType.id) && selectedType.id == 2 && !model.printer_is_usb)" class="form-group">
                          <label class="control-label">USB</label>
                          <input
                            type="text"
                            v-model="model.usb_path"
                            name="usb_path"
                            placeholder="USB"
                            class="form-control" >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Right column -->
              <div class="col-lg-6">

                <!-- Setări tip -->
                <div class="settings-section">
                  <div class="settings-section-header">
                    <span class="settings-section-icon"><i class="ti-settings"></i></span>
                    <h3>{{ $t('printer.sectionType') }}</h3>
                  </div>
                  <div class="settings-section-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingTable.type')}}</label>
                          <v-select
                            v-model="selectedType"
                            :options="types"
                            :reduce="item => item.id"
                            label="name"
                            name="type-select"
                            :placeholder="$t('settingTable.type')">
                          </v-select>

                          <input
                            type="hidden"
                            v-model="model.type"
                            name="type"
                            v-validate="'required'"
                          />

                          <small class="text-danger" v-if="errors.has('type')">
                            {{ getError('type') }}
                          </small>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="selectedType && ![3,5].includes(selectedType.id)">
                        <div class="form-group label-input">
                          <label>{{$t('printer.printerReceipt')}}</label>
                          <p-switch v-model="model.print_receipts" type="success" ></p-switch>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="selectedType && selectedType.id == 2">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('settingTable.maps')}}</label>
                          <el-select
                            multiple
                            collapse-tags
                            value-key="id"
                            v-model="model.table_maps"
                            style="width: 100%; height: auto; min-height: 40px;"
                            :placeholder="$t('general.all')">
                            <el-option
                              v-for="map in maps"
                              :key="map.id"
                              :label="map.name"
                              :value="map">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="selectedType && selectedType.id == 5">
                      <label>{{ $t('printer.orderLabelPrintMode') }}</label>
                      <select v-model="model.order_label_print_mode" class="form-control">
                        <option value="grouped">{{ $t('printer.orderLabelGrouped') }}</option>
                        <option value="per_product">{{ $t('printer.orderLabelPerProduct') }}</option>
                      </select>
                      <small v-if="model.order_label_print_mode === 'per_product'" class="help-block order-label-hint">
                        {{ $t('printer.orderLabelPerProductHint') }}
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Opțiuni și integrări -->
                <div class="settings-section" v-if="selectedType && ![3,5].includes(selectedType.id)">
                  <div class="settings-section-header">
                    <span class="settings-section-icon"><i class="ti-control-shuffle"></i></span>
                    <h3>{{ $t('printer.sectionOptions') }}</h3>
                  </div>
                  <div class="settings-section-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div v-if="!model.print_receipts" class="form-group">
                          <label>{{$t('kds.section')}}</label>
                          <v-select
                            v-model="model.section"
                            :options="sections"
                            value="id"
                            label="name"
                            :placeholder="$t('general.all')">
                          </v-select>
                          <small class="text-danger" v-if="errors.has('section')">
                            {{ getError('section') }}
                          </small>
                        </div>
                        <div v-if="model.print_receipts" class="form-group">
                          <label class="control-label">{{$t('catalogProdOpt.posid')}}</label>
                          <input
                            type="text"
                            v-model="model.pos_id"
                            name="pos_id"
                            placeholder="42"
                            class="form-control">
                        </div>
                        <div v-if="!model.print_receipts" class="form-group">
                          <label>{{$t('printer.fontSize')}}</label>
                          <v-select
                            v-model="selectedFontSize"
                            :name="$t('printer.fontSize')"
                            :options="fontSizes"
                            :reduce="option => option.id"
                            label="name"
                            clearable="false"
                            :placeholder="$t('printer.fontSize')">
                          </v-select>
                          <small class="text-danger" v-if="errors.has($t('printer.fontSize'))">
                            {{ getError($t('printer.fontSize')) }}
                          </small>
                        </div>
                        <div v-if="model.print_receipts" class="form-group">
                          <label>{{$t('printer.correspondingPos')}}</label>
                          <el-select
                            multiple
                            collapse-tags
                            value-key="id"
                            label="name"
                            v-model="model.pos_ids"
                            style="width: 100%; height: auto; min-height: 40px;"
                            :placeholder="$t('printer.none')">
                            <el-option
                              v-for="item in posList"
                              :key="item.id"
                              :label="item.name"
                              :value="item">
                            </el-option>
                          </el-select>
                          <small class="text-danger" v-if="errors.has('section')">
                            {{ getError('section') }}
                          </small>
                        </div>
                        <div v-if="model.print_receipts" class="form-group">
                          <label>{{$t('printer.paymentMethodsPrintTwice')}}</label>
                          <el-select
                            multiple
                            collapse-tags
                            v-model="model.print_receipt_twice_payment_methods"
                            style="width: 100%; height: auto; min-height: 40px;"
                            value-key="id"
                            label="name"
                            :placeholder="$t('printer.none')">
                            <el-option
                              v-for="item in paymentMethods"
                              :key="item.id"
                              :label="item.name"
                              :value="item">
                            </el-option>
                          </el-select>
                          <small class="text-danger" v-if="errors.has('section')">
                            {{ getError('section') }}
                          </small>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div v-if="model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.printOptions')}}</label>
                          <p-switch v-model="model.print_options" type="success" ></p-switch>
                        </div>
                        <div v-if="!model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.printAddress')}}</label>
                          <p-switch v-model="model.print_address_on_section" type="success" ></p-switch>
                        </div>
                        <div v-if="selectedType && selectedType.id == 2 && !model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.hideSingleOptionQty')}}</label>
                          <p-switch v-model="model.hide_single_option_qty" type="success" ></p-switch>
                        </div>
                        <div v-if="selectedType && selectedType.id == 2 && !model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.displayPricesAndTotals')}}</label>
                          <p-switch v-model="model.display_prices_and_totals" type="success" ></p-switch>
                        </div>
                        <div v-if="model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.printProductClientComments')}}</label>
                          <p-switch v-model="model.print_product_comments" type="success" ></p-switch>
                        </div>
                        <div v-if="model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.printHotelFields')}}</label>
                          <p-switch v-model="model.print_hotel_fields" type="success" ></p-switch>
                        </div>
                        <div class="form-group label-input">
                          <label>{{$t('printer.mergeItems')}}</label>
                          <p-switch v-model="model.merge_items" type="success" ></p-switch>
                        </div>
                        <div v-if="model.print_receipts" class="form-group label-input">
                          <label>{{$t('printer.groupItemsByCategoryOnReceipt')}}</label>
                          <p-switch v-model="model.group_items_by_category_on_receipt" type="success" ></p-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import PSwitch from 'src/components/UIComponents/Switch.vue'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      PSwitch
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      let sessionData = this.$session.get('selectedCompanyData')

      this.locations = sessionData.locations_details
      this.getSections()
      this.getMaps()

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      if (!sessionData['compact_pos_list'] || !sessionData['compact_pos_list'].length) {
        this.apiRequest('/pos-admin/compact-list', 'GET', data, (response) => {
          if (response.status) {
            this.posList = response.data
            sessionData['compact_pos_list'] = response.data
            this.$session.set('compact_pos_list', response.data)
          }
        })
      } else {
        this.posList = sessionData['compact_pos_list']
      }

      const fetchPosList = () => {
        return new Promise((resolve) => {
          if (!sessionData['compact_pos_list'] || !sessionData['compact_pos_list'].length) {
            this.apiRequest('/pos-admin/compact-list', 'GET', data, (response) => {
              if (response.status) {
                this.posList = response.data
                sessionData['compact_pos_list'] = response.data
                this.$session.set('compact_pos_list', response.data)
                resolve()
              } else {
                resolve() // resolve even on failure, to avoid hanging
              }
            })
          } else {
            this.posList = sessionData['compact_pos_list']
            resolve()
          }
        })
      }

      fetchPosList().then(() => {
        if (this.route.params.id) {
          this.loading = true
          this.getData()
        }
      })

      // if (this.route.params.id) {
      //   this.loading = true
      //   this.getData()
      // }
    },
    mounted () {
      this.getSections()
    },
    watch: {
      'model.type' (val) {
        this.$validator.validate('type')
      },
      'model.location' (newVal, oldVal) {
        if (oldVal && newVal && oldVal.true_id !== newVal.true_id) {
          this.getMaps(true)
        } else if (newVal && (!oldVal || !oldVal.true_id)) {
          this.getMaps()
        }
      }
    },
    computed: {
      selectedType: {
        get () {
          return this.types.find(t => t.id === this.model.type) || null
        },
        set (value) {
          const previousType = this.model.type
          this.model.type = value ? value.id : null
          if (previousType !== this.model.type && ![2, 3].includes(this.model.type)) {
            this.model.printer_is_usb = false
          }
          if (previousType !== this.model.type && this.model.type === 5) {
            this.model.order_label_is_lan = false
          }
          this.$validator.validate('type')
        }
      },
      orderLabelIsLan: {
        get () {
          return !!this.model.order_label_is_lan
        },
        set (value) {
          this.model.order_label_is_lan = !!value
        }
      },
      selectedFontSize: {
        get () {
          return this.fontSizes.find(t => t.id === this.model.font_size) || this.fontSizes.find(t => t.id === '1')
        },
        set (value) {
          this.model.font_size = value ? value.id : '1'
        }
      }
    },
    data () {
      return {
        id: this.route.params.id || null,
        model: {
          id: null,
          type: null,
          location: null,
          section: null,
          table_maps: [],
          printer_is_usb: false,
          order_label_is_lan: false,
          print_receipts: false,
          order_label_print_mode: 'grouped',
          ip: null,
          port: null,
          hide_single_option_qty: false,
          display_prices_and_totals: false
        },
        modelValidations: {
          location: {
            required: true
          },
          ip: {
            required: true
          },
          port: {
            required: true
          }
        },
        isNew: true,
        loading: true,
        locations: [],
        posList: [],
        sections: [],
        maps: [],
        printerTypes: [
          {id: 1, name: 'Standard'},
          {id: 2, name: 'V2'}
        ],
        types: [
          {id: 1, name: 'Port Forwarding'},
          {id: 2, name: 'Local'},
          {id: 3, name: 'Label Local'},
          {id: 4, name: 'USB'},
          {id: 5, name: 'Order Label'}
        ],
        paymentMethods: [
          {id: 'CASH', name: this.$t('paymentTypes.CASH')},
          {id: 'CARD', name: this.$t('paymentTypes.CARD')},
          {id: 'POS', name: this.$t('paymentTypes.POS')},
          {id: 'CARD_POS', name: this.$t('paymentTypes.CARD_POS')},
          {id: 'CASH_MACHINE', name: this.$t('paymentTypes.CASH_MACHINE')},
          {id: 'POS_KIOSK', name: this.$t('paymentTypes.POS_KIOSK')},
          {id: 'VIVA_INTENT', name: this.$t('paymentTypes.VIVA_INTENT')},
          {id: 'VIRAMENT', name: this.$t('paymentTypes.VIRAMENT')},
          {id: 'SPLIT', name: this.$t('paymentTypes.SPLIT')},
          {id: 'ROOM', name: this.$t('paymentTypes.ROOM')},
          {id: 'EVENT', name: this.$t('paymentTypes.EVENT')},
          {id: 'PROTOCOL', name: this.$t('paymentTypes.PROTOCOL')},
          {id: 'MANCARE_PERSONAL', name: this.$t('paymentTypes.MANCARE_PERSONAL')},
          {id: 'GLOVO', name: this.$t('paymentTypes.GLOVO')},
          {id: 'BOLT', name: this.$t('paymentTypes.BOLT')},
          {id: 'WOLT', name: this.$t('paymentTypes.WOLT')}
        ],
        fontSizes: [{id: 1, name: this.$t('general.normal')}, {id: 2, name: this.$t('general.big')}]
      }
    },
    methods: {
      getData () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/printer/' + this.id, 'GET', data, (response) => {
          if (response.status) {
            this.model = response.data
            Vue.set(this.model, 'order_label_print_mode', this.model.order_label_print_mode || 'grouped')
            Vue.set(this.model, 'order_label_is_lan', !!this.model.order_label_is_lan)

            this.model.printer_type = this.printerTypes.find(
              p => p.id === this.model.printer_type
            ) || null

            if (this.model.print_receipt_twice_payment_methods && this.model.print_receipt_twice_payment_methods.length) {
              let mappedBack = this.model.print_receipt_twice_payment_methods.map(id => ({
                id: id,
                name: this.$t(`paymentTypes.${id}`)
              }))
              Vue.set(this.model, 'print_receipt_twice_payment_methods', mappedBack)
            }

            if (this.posList && this.posList.length && this.model.pos_ids && this.model.pos_ids.length) {
              let mappedBack1 = this.model.pos_ids.map(id => {
                const pos = this.posList.find(p => p.id === id)
                return {
                  id: id,
                  name: pos ? pos.name : ''
                }
              })
              Vue.set(this.model, 'pos_ids', mappedBack1)
            }

            this.getMaps()
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getSections () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/sections', 'GET', data, (response) => {
          if (response.status) {
            this.sections = response.data
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getMaps (resetSelection = false) {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if (this.model.location && this.model.location.true_id) {
          data.location_id = this.model.location.true_id
        }
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response.status) {
            this.maps = response.data.table_maps || []
            if (resetSelection) {
              Vue.set(this.model, 'table_maps', [])
            } else {
              this.mapTableMapsFromApi()
            }
          }
        })
      },
      mapTableMapsFromApi () {
        if (Array.isArray(this.model.table_maps) && this.model.table_maps.length && typeof this.model.table_maps[0] === 'object') {
          return
        }

        let mapIds = []
        if (Array.isArray(this.model.table_map_ids) && this.model.table_map_ids.length) {
          mapIds = this.model.table_map_ids
        } else if (this.model.table_map_id) {
          mapIds = Array.isArray(this.model.table_map_id)
            ? this.model.table_map_id
            : [this.model.table_map_id]
        }

        if (!mapIds.length || !this.maps.length) {
          return
        }

        Vue.set(this.model, 'table_maps', mapIds.map(id => {
          const map = this.maps.find(m => m.id === id)
          return {
            id: id,
            name: map ? map.name : ''
          }
        }))
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          console.log(this.model.print_receipts)
          if (isValid) { this.updateOrCreatePrinter() }
        })
      },
      updateOrCreatePrinter () {
        let data = { ...this.model }
        data.company_id = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')

        if (this.model.section) {
          data.section_id = this.model.section.id
        } else {
          data.section_id = null
        }

        if (this.model.table_maps && this.model.table_maps.length) {
          data.table_map_ids = this.model.table_maps.map(item => item.id)
        } else {
          data.table_map_ids = []
        }

        data.location_id = this.model.location.true_id
        if (this.model.printer_type) {
          data.printer_type = this.model.printer_type.id
        } else {
          data.printer_type = null
        }

        if (this.model.print_receipt_twice_payment_methods && this.model.print_receipt_twice_payment_methods.length) {
          let result = this.model.print_receipt_twice_payment_methods.map(item => item.id)
          data.print_receipt_twice_payment_methods = result
        }

        if (this.model.pos_ids && this.model.pos_ids.length) {
          let result = this.model.pos_ids.map(item => item.id)
          data.pos_ids = result
        }

        // send an explicit boolean so an untouched switch isn't dropped from the
        // payload (undefined) and defaulted to true by the backend
        data.print_receipts = !!this.model.print_receipts
        data.order_label_print_mode = this.model.type === 5
          ? (this.model.order_label_print_mode || 'grouped')
          : 'grouped'
        data.order_label_is_lan = this.model.type === 5 && !!this.model.order_label_is_lan

        let url = '/printer/'
        let httpMethod = ''

        if (this.id) {
          url += this.id
          httpMethod = 'PUT'
        } else {
          httpMethod = 'POST'
        }

        this.apiRequest(url, httpMethod, data, response => {
          if (response.status === true) {
            const entityId = this.id || (response.data && response.data.id) || null
            this.trackAdminEvent('ADMIN_PRINTER_UPDATE', 'printer', entityId, {
              printer_id: entityId,
              name: data.name || (this.model && this.model.name) || null,
              request: data,
              response: response
            })
            swal(
              '',
              'Success',
              'success'
            )
            this.backButton()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      handleDelete () {
        swal({
          text: this.$t('printer.deleteConfirm'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no')
        })
        .then(() => {
          this.$nextTick(() => { this.loading = true })
          var data = {
            company_id: this.$session.get('selectedCompany'),
            token: this.$session.get('token'),
            delete: true
          }
          this.apiRequest('/printer/' + this.id, 'DELETE', data, (response) => {
            if (response.status) {
              this.trackAdminEvent('ADMIN_PRINTER_DELETED', 'printer', this.id, {
                printer_id: this.id,
                name: (this.model && this.model.name) || null
              })
              this.$nextTick(() => { this.loadingReset = false })
              swal({'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
              .then(() => {})
              .catch(() => {})
              this.backButton()
            } else {
              this.$nextTick(() => { this.loadingReset = false })
              swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
              .then(() => {})
              .catch(() => {})
            }
          })
        })
        .catch(() => {})
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.$session.set('selectedTab', this.$t('settingsPages.printers'))
        // this.router.push('/settings')
      }
    }
  }
</script>
<style scoped>
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .el-select .el-tag {
    background-color: #674BD2 !important;
    color: white;
    padding: 2px 12px;
  }

  span .el-tag {
    padding-top: 7px !important;
    height: 36px !important;
  }

  /* ---- Header ---- */
  .printer-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }
  .printer-heading {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .printer-heading-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #eef2ff;
    color: #4c6ef5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }
  .printer-heading-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.2;
  }
  .printer-heading-subtitle {
    margin: 2px 0 0;
    font-size: 14px;
    color: #64748b;
  }
  .printer-actions {
    align-items: center;
    margin-bottom: 0;
  }

  /* ---- Layout ---- */
  .printer-form-card.card {
    background: transparent;
    box-shadow: none;
    border: none;
    margin-top: 15px;
  }
  .printer-form-card.card .card-content {
    padding: 0;
  }
  .printer-sections {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }

  /* ---- Section cards ---- */
  .settings-section {
    background: #ffffff;
    border: 1px solid #eef0f4;
    border-radius: 16px;
    padding: 22px 24px;
    margin-bottom: 20px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  }
  .settings-section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
  }
  .settings-section-icon {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #eef2ff;
    color: #4c6ef5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }
  .settings-section-header h3 {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
  }
  .settings-section .form-group > label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
  }
  .settings-section .form-control {
    border-radius: 10px;
  }
  .settings-section .form-group {
    margin-bottom: 10px;
  }

  /* Label + switch rows */
  .settings-section .label-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 34px;
    margin-bottom: 6px;
  }
  .settings-section .label-input > label {
    margin-bottom: 0;
  }
  .order-label-hint {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Printer/PrinterForm.vue